import { InfoLoginResponse } from "@/services/get-info-login"

export function shouldShowPreRegistrationSteps({
  infoContoResults,
}: InfoLoginResponse) {
  if (!infoContoResults) return false

  const isAffiliationRegistration = infoContoResults.some(
    ({ key, value }: { key: string; value?: string }) => {
      return key === "FLAG_AFFILIATION" && value === "1"
    },
  )

  const hasCustomerCompletedPreLoginFlow = infoContoResults.some(
    ({ key, value }: { key: string; value?: string }) => {
      return key === "FLAG_PRIMA_LOGIN_AFFILIATION" && value === "1"
    },
  )

  const isFlagPrimaLoginAffiliationEnabled =
    isAffiliationRegistration && !hasCustomerCompletedPreLoginFlow

  return isFlagPrimaLoginAffiliationEnabled
}
